<h1 class="text-dark text-xl" mat-dialog-title>Nuova Pratica di Noleggio</h1>
<div class="w-full" mat-dialog-content>
  <app-rentable-practice-form
    (closeDialogEvent)="closeDialog()"
    [data]="data.rentPractice"
  ></app-rentable-practice-form>
</div>
